/**
 * Registers the PWA service worker (public/sw.js).
 *
 * Production only: in dev the service worker would serve stale bundles and make
 * hot reload confusing, so any previously installed worker is unregistered instead.
 * A registration failure only means no offline support — it must never break the app.
 */
export function registerServiceWorker() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  if (process.env.NODE_ENV !== 'production') {
    navigator.serviceWorker
      .getRegistrations?.()
      .then((registrations) => registrations.forEach((registration) => registration.unregister()))
      .catch(() => {});
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
